// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"cta-button-rework_ctaButton_31W","large":"cta-button-rework_large_2ZC"};